import { useEffect, useState } from 'react';

import { usePresenterOrAttendee } from '../context/AttendeeAndPresenterProvider';

import QuestionComponent from './QuestionComponent';
import ISI from '../common/ISI';
// import NumberQuestionComponent from './NumberQuestionComponent';
const logo = require('../../assets/top_logo.png');

const GameComponent = () => {
  const { currentQuestion, gameState, submitResponse, questions } = usePresenterOrAttendee();

  const [isIdleOrEnded, setIsIdleOrEnded] = useState(true);
  const [isClosed, setIsClosed] = useState(true);

  useEffect(() => {
    console.log('game state in Game Component', gameState);

    if (
      gameState.state === 'initial' ||
      !gameState.state ||
      !currentQuestion ||
      ['new'].includes(gameState.questionState) ||
      gameState.state === 'ended'
    ) {
      setIsIdleOrEnded(true);
    } else {
      setIsIdleOrEnded(false);
      console.log('questionState', gameState.questionState);
      setIsClosed(gameState.questionState === 'closed');
    }
  }, [gameState, currentQuestion, questions]);

  return (
    <div className={`question-wrapper ${isIdleOrEnded ? 'question' : 'question-live'}`}>
      {isIdleOrEnded ? (
        <>
          <img src={logo} alt="logo" className="waiting-logo top-img" />
          <h1 style={{ textAlign: 'center', margin: '0 5%', fontSize: '4vh' }}>
            {gameState.state === 'ended' ? 'Thank you!' : 'Meeting the Challenges of ADHD Symptom Control'}
          </h1>
        </>
      ) : (
        <QuestionComponent
          isIdleOrEnded={isIdleOrEnded}
          currentQuestion={currentQuestion}
          gameState={gameState}
          submitResponse={submitResponse}
          isClosed={isClosed}
        />
      )}
      <ISI />
    </div>
  );
};

export default GameComponent;
